<template>
    <sa-page-layout :btnNewVisible="false" :btnRefreshVisible="true" @refresh="onRefresh" :pathResource="pathResource" :linkedit="linkedit" :showModalLoading="showModalLoading">
        <template slot="toolbar">
            <b-button variant="btn-toolbar btn btn-outline-primary" size="md" @click="onClickExportCsv">
                <i class="bi bi-download sa-icon-i"></i>
                Export CSV
            </b-button>
        </template>
        <template slot="table-filter">
            <b-form @submit.prevent="onSubmit">
                <b-row>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Data dal</label>
                        <date-picker v-model="filtro.dataDal" format="DD-MM-YYYY HH:mm" value-type="timestamp" placeholder="Seleziona data iniziale" type="datetime"> </date-picker>
                    </b-col>
                    <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
                        <label class="sa-label-data">Data al</label>
                        <date-picker v-model="filtro.dataAl" format="DD-MM-YYYY HH:mm" value-type="timestamp" placeholder="Seleziona data finale" type="datetime"> </date-picker>
                    </b-col>
                </b-row>
            </b-form>
            <b-row>
                <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="sa-padding-right pt-3 pb-3 text-right">
                    <b-button type="submit" variant="info" @click="onSubmit">{{ this.$i18n.t("patients.lblFind") }}</b-button>
                    <b-button type="reset" variant="danger" @click="onReset">{{ this.$i18n.t("patients.lblResetFilter") }}</b-button>
                </b-col>
            </b-row>
        </template>
        <template slot="table-body">
            <phs-logs-list-component ref="PhsLogsListComponent" @beforeLoadData="onBeforeLoadData" @afterLoadData="onAfterLoadData"></phs-logs-list-component>
        </template>
    </sa-page-layout>
</template>

<script>
import axios from "axios";
import moment from "moment";
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
import DatePicker from "vue2-datepicker";
import PhsLogsListComponent from "../components/PhsLogsListComponent.vue";
export default {
    components: { SaPageLayout, PhsLogsListComponent, DatePicker },
    data() {
        return {
            filtro: { dataDal: null, dataAl: null },
            btnNewVisible: true,
            btnBackVisible: true,
            linkback: "/home",
            pathResource: "/",
            pathResourceDownload: "/phslogs/downoadcsv",
            linkedit: "",
            showModalLoading: false,
            listKey: 0,
        };
    },
    mounted() {
        let me = this;
        me.loadData();
    },
    methods: {
        onClickExportCsv() {
            let me = this;
            me.showModalLoading = true;
            let link = process.env.VUE_APP_PATH_API + me.pathResourceDownload;
            let fileName = "Export Log PHS " + moment(new Date()).format("DD MM YYYY HH-mm") + ".csv";
            console.log(me.filtro);

            axios({
                url: link,
                params: { dal: me.filtro.dataDal, al: me.filtro.dataAl },
                method: "GET",
                responseType: "blob",
            })
                .then((response) => {
                    // console.log(response.data);
                    var blob = new Blob([response.data]);
                    var downloadElement = document.createElement("a");
                    var href = window.URL.createObjectURL(blob);
                    downloadElement.href = href;
                    downloadElement.download = fileName;
                    document.body.appendChild(downloadElement);
                    downloadElement.click();
                    document.body.removeChild(downloadElement);
                    window.URL.revokeObjectURL(href);
                    me.showModalLoading = false;
                })
                .catch(() => {
                    me.showModalLoading = false;
                });
        },
        loadData() {
            let me = this;
            me.$refs.PhsLogsListComponent.loadData(me.filtro);
        },
        onRefresh() {
            let me = this;
            me.loadData();
        },
        onAfterLoadData() {
            let me = this;
            me.showModalLoading = false;
        },
        onBeforeLoadData() {
            let me = this;
            me.showModalLoading = true;
        },
        onReset() {
            let me = this;
            me.filtro = {};
            // let sessionStorage = window.sessionStorage;
            // sessionStorage["filtro"] = JSON.stringify(me.filtro);
            me.loadData();
        },
        onSubmit() {
            let me = this;
            // let sessionStorage = window.sessionStorage;
            // sessionStorage["filtro"] = JSON.stringify(me.filtro);
            me.loadData();
        },
    },
};
</script>

<style></style>
